export default {"src":"/_next/static/media/BereavmentCategoryActive.f65fc9bf.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};